import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import cardo from '../assets/card-1.png'
import cardt from '../assets/card-2.png'
import cardth from '../assets/card-3.png'
import cardf from '../assets/card-4.png'
import cardfv from '../assets/card-5.png'
import searchvec from '../assets/sub.svg'



const SearchComp = () => {
    
    const [show , setShow] = useState(false)
    return (
        <>
         
            <div className='search-main'>
                <div className='search-main-wrap md:flex container mx-auto my-11'>

                    {/* left side start */}
                    <div className='search-left-side order-1 mx-4  md:w-[30%]  '>
                        <div>
                            <div className='flex justify-between'>
                                <h1 className='text-[18px] font-semibold  '>Filter by</h1>
                                <p className=' text-[#409BF5] pt-1 font-semibold text-[12px] cursor-pointer '>Reset filters</p>
                            </div>


                            {/* charge filter */}
                            <div className='charge border mb-7 border-gray-300 rounded-[20px] my-2 py-2 px-5'>
                                <div>
                                    <h2 className='text-[14px] text-[#272C34]  font-semibold  '>Charge range</h2>
                                    <select className=' outline-none text-gray-400 border border-gray-300 rounded-lg h-[40px] bg-[#FBFEFF]  md:hidden lg:hidden  w-[80%] '>
                                                    <option disabled>Select Range</option>
                                                    <option>$</option>
                                                    <option>$$</option>
                                                    <option>$$$</option>
                                                    <option>$$$$</option>
                                                </select>
                                </div>
                                
                                <div>
                                

                                    <form className='my-3 hidden md:block '>

                                        <div className="  md:items-center mb-1">
                                            <label className="md:w-2/3 block text-gray-500 font-bold">
                                                <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span className="text-[12px] font-normal">
                                                    $
                                                </span>
                                            </label>
                                        </div>

                                        <div className="  md:items-center mb-1">
                                            <label className="md:w-2/3 block text-gray-500 font-bold">
                                                <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span className="text-[12px] font-normal">
                                                    $$
                                                </span>
                                            </label>
                                        </div>

                                        <div className="  md:items-center mb-1">
                                            <label className="md:w-2/3 block text-gray-500 font-bold">
                                                <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span className="text-[12px] font-normal">
                                                    $$$
                                                </span>
                                            </label>
                                        </div>

                                        <div class="  md:items-center  ">
                                            <label class="md:w-2/3 block text-gray-500 font-bold">
                                                <input class="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span class="text-[12px] font-normal">
                                                    $$$$
                                                </span>
                                            </label>
                                        </div>


                                    </form>
                                </div>
                            </div>
                            {/* charge filter end */}



                            {/* Refreshment filter */}
                            <div className='charge border mb-7 border-gray-300 rounded-[20px] my-2 py-2 px-5'>
                                <div>
                                    <h2 className='text-[14px] text-[#272C34]  font-semibold  '>Refreshment</h2>
                                    <select className=' outline-none text-gray-400 border border-gray-300 rounded-lg h-[40px] bg-[#FBFEFF]  md:hidden lg:hidden  w-[80%] '>
                                                    <option disabled>YES / NO</option>
                                                    <option>YES</option>
                                                    <option>NO</option>
                                                </select>
                                </div>
                                <div>

                                    <form className='my-3 hidden md:block lg:block'>

                                        <div className="  md:items-center mb-1">
                                            <label className="md:w-2/3 block text-gray-500 font-bold">
                                                <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span className="text-[12px] font-normal">
                                                    Yes
                                                </span>
                                            </label>
                                        </div>

                                        <div className="  md:items-center mb-1">
                                            <label className="md:w-2/3 block text-gray-500 font-bold">
                                                <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span className="text-[12px] font-normal">
                                                    No
                                                </span>
                                            </label>
                                        </div>



                                    </form>
                                </div>
                            </div>
                            {/* Refreshment End */}


                            {/* country / city start */}

                            <div className='charge border mb-7 border-gray-300 rounded-[20px] my-2 py-2 px-5'>
                                <div>
                                    <h2 className='text-[14px] text-[#272C34]  font-semibold '>Country / City</h2>
                                </div>
                                <div>

                                    <form className='my-3'>

                                        <div className="  md:items-center mb-1">
                                            <div className='border border-gray-300 rounded-lg pl-2 md:w-[100%]  py-2'>
                                                <select className=' text-xs outline-none text-gray-400 bg-[#FBFEFF] md:w-[80%]'>
                                                    <option  >select Country</option>
                                                    <option>Germany</option>
                                                    <option>Pakistan</option>
                                                </select>
                                                <span className='  md:h-5 w-5  cursor-pointer'>
                                                    <i class="fa-solid fa-location-crosshairs float-right mr-4 text-blue-400 text-xl"></i>
                                                </span>
                                            </div>
                                        </div>

                                        <div className=" text-xs md:items-center mb-1">
                                            <div className='border border-gray-300 rounded-lg px-2 md:w-[100%] my-2 py-2'>
                                                <select className=' outline-none text-gray-400 bg-[#FBFEFF] md:w-full '>
                                                    <option>Select City</option>
                                                    <option>Berlin</option>
                                                    <option>New York</option>
                                                </select>

                                            </div>
                                        </div>

                                        <div className="  md:items-center mb-1">

                                        </div>



                                    </form>
                                </div>
                            </div>
                            {/* country / city End */}

                            {/* start ratings */}

                            <div className='charge border mb-7 border-gray-300 rounded-[20px] my-2 py-2 px-5'>

                                <div>
                                    <div className='flex justify-between'>
                                        <h1 className=' text-[14px] text-[#272C34]  font-semibold '>Ratings</h1>
                                        <p className=' text-gray-600  pt-1 font-normal text-[12px]  '>Not Selected</p>
                                    </div>
                                    <center>
                                        <form className='my-3 mx-auto'>
                                        <i class="fa-solid fa-star text-[40px] text-[#E0E0E0]"></i>
                                        <i class="fa-solid fa-star text-[40px] text-[#E0E0E0]"></i>
                                        <i class="fa-solid fa-star text-[40px] text-[#E0E0E0]"></i>
                                        <i class="fa-solid fa-star text-[40px] text-[#E0E0E0]"></i>
                                        <i class="fa-solid fa-star text-[40px] text-[#E0E0E0]"></i>
 
                                        </form>
                                    </center>
                                </div>
                            </div>

                            {/* ratings End */}


                            {/* distance start */}

                            <div className='charge border mb-7 border-gray-300 rounded-[20px] my-2 py-2 px-5'>
                                <div>
                                    <h2 className='text-[14px] text-[#272C34]  font-semibold  '>Distance</h2>
                                    <select className=' outline-none text-gray-400  border  border-gray-300 rounded-lg h-[40px] bg-[#FBFEFF] md:hidden lg:hidden  w-[80%] '>
                                                    <option disabled>Select Range</option>
                                                    <option>Cit-wide</option>
                                                    <option>Driving (5 mi)</option>
                                                    <option>Biking (2 mi)</option>
                                                    <option>Walking (1 mi)</option>
                                                    <option>Within (4 blocks)</option>
                                                </select>
                                </div>
                                <div>

                                    <form className='my-3  hidden md:block lg:block'>

                                        <div className="  md:items-center mb-1">
                                            <label className="md:w-2/3 block text-gray-500 font-bold">
                                                <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span className="text-[12px] font-normal">
                                                    Cit-wide
                                                </span>
                                            </label>
                                        </div>

                                        <div className="  md:items-center mb-1">
                                            <label className="md:w-2/3 block text-gray-500 font-bold">
                                                <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span className="text-[12px] font-normal">
                                                    Driving (5 mi)
                                                </span>
                                            </label>
                                        </div>

                                        <div className="  md:items-center mb-1">
                                            <label className="md:w-2/3 block text-gray-500 font-bold">
                                                <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span className="text-[12px] font-normal">
                                                    Biking (2 mi)
                                                </span>
                                            </label>
                                        </div>

                                        <div class="  md:items-center  ">
                                            <label class="md:w-2/3 block text-gray-500 font-bold">
                                                <input class="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span class="text-[12px] font-normal">
                                                    Walking (1 mi)
                                                </span>
                                            </label>
                                        </div>
                                        <div class="  md:items-center  ">
                                            <label class="md:w-2/3 block text-gray-500 font-bold">
                                                <input class="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                                <span class="text-[12px] font-normal">
                                                    Within (4 blocks)
                                                </span>
                                            </label>
                                        </div>


                                    </form>
                                </div>
                            </div>
                            {/* charge filter end */}

                        </div>
                    </div>



                    {/* Left Side div End */}



                    {/* Left side start */}


                    <div className='search-right-side order-2   w-full '>

                        <div className='search-bar-right-wrap md:w-[98%] w-[95%] mx-auto'>

                            {/* serach bar */}

                           
    <div className='flex border w-[95%] mx-auto border-gray-200 rounded-full'>
        {/* <i class="fa-solid fa-angles-down text-gray-300  text-2xl -mr-6 z-40 pt-2 pl-6 absolute  "></i> */}
        <img src={searchvec} alt='imgg' className='  ml-3 mt-3 h-[25px] w-[35px]'  />
         <input className='w-full ml-3 h-12 bg-[#FBFEFF] rounded-full pl-3 outline-none reltive md:text-xs text-xs ' type='text' placeholder='Search a padel court to book' />
        <div className='bg-[#e8f4fe] h-12 cursor-pointer w-20 pt-2 rounded-r-full -ml-16'>
        <i class="fa-solid fa-location-crosshairs text-blue-600 ml-5     text-2xl   "></i>
   
        </div> 
        </div>

                            <div className='my-6'>
                                <h1 className='text-[18px] text-[#272C34]  font-semibold font-semibold'>12 results</h1>
                            </div>


                            {/* search result cards */}
                            <div className='md:md:flex my-6'>

                                <div className='card-img   md:w-[65%] w-[90%] mx-auto '>
                                    <img src={cardo} alt='card img' className=' w-full md:w-[276px] h-[368px]  ' />
                                </div>

                                <div className='card-text mx-4 md:mx-0'>
                                    <h1 className='text-[24px] text-[#272C34] font-bold py-1'>Padel Buddy Court name</h1>
                                    <p className='text-[#6A7D95] leading-[16px] font-normal text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                        Aliquam ullamcorper tempus sodales. Proin malesuada metus
                                        sed orci vestibulum dapibus. Morbi in mi sit amet quam feugiat
                                        faucibus. Proin nec elit varius, consequat erat ut,  </p>
                                    <h2 className='pt-3 text-[#272C34] text-[12px] font-bold'> Location </h2>
                                    <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                                    <h1 className='pt-3 text-[12px] font-bold text-[#272C34]'>Timings  <strong className=' pl-3 text-lime-500'> ︳Open Now</strong> </h1>

                                    <h1 className='py-3 text-[12px] text-[#272C34] '><strong>Services </strong></h1>
                                    <div className='flex justify-between  md:ml-8 md:w-[50%] mx-4  '>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>

                                            </ul>
                                        </div>
                                    </div>
                                    <h1 className='text-[#409BF5] text-[12px] py-4'><strong>View detail </strong></h1>
                                   <Link to="/BookCourt" > <button className='w-full bg-[#e8f4fe] rounded-lg py-3 text-[#409bf5] text-[14px] font-bold'>Book Now </button></Link>
                                </div>
                            </div>


                            <div className='md:md:flex my-6'>

                                <div className='card-img   md:w-[65%] w-[90%] mx-auto'>
                                    <img src={cardt} alt='card img' className=' w-full md:w-[276px] h-[368px] ' />
                                </div>

                                <div className='card-text mx-4 md:mx-0'>
                                    <h1 className='text-[24px] text-[#272C34] font-bold py-1'>Padel Buddy Court name</h1>
                                    <p className='text-[#6A7D95] leading-[16px] font-normal text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                        Aliquam ullamcorper tempus sodales. Proin malesuada metus
                                        sed orci vestibulum dapibus. Morbi in mi sit amet quam feugiat
                                        faucibus. Proin nec elit varius, consequat erat ut,  </p>
                                    <h2 className='pt-3 text-[#272C34] text-[12px] font-bold'> Location </h2>
                                    <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                                    <h1 className='pt-3 text-[12px] font-bold text-[#272C34]'>Timings  <strong className=' pl-3 text-lime-500'> ︳Open Now</strong> </h1>

                                    <h1 className='py-3 text-[12px] text-[#272C34] '><strong>Services </strong></h1>
                                    <div className='flex justify-between md:ml-8 md:w-[50%] mx-4  '>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>

                                            </ul>
                                        </div>
                                    </div>
                                    <h1 className='text-[#409BF5] text-[12px] py-4'><strong>View detail </strong></h1>
                                   <Link to="/BookCourt" > <button className='w-full bg-[#e8f4fe] rounded-lg py-3 text-[#409bf5] text-[14px] font-bold'>Book Now </button></Link>
                                </div>
                            </div>


                            <div className='md:md:flex my-6'>

                                <div className='card-img   md:w-[65%] w-[90%] mx-auto'>
                                    <img src={cardth} alt='card img' className='w-full md:w-[276px] h-[368px] ' />
                                </div>

                                <div className='card-text mx-4 md:mx-0'>
                                    <h1 className='text-[24px] text-[#272C34] font-bold py-1'>Padel Buddy Court name</h1>
                                    <p className='text-[#6A7D95] leading-[16px] font-normal text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                        Aliquam ullamcorper tempus sodales. Proin malesuada metus
                                        sed orci vestibulum dapibus. Morbi in mi sit amet quam feugiat
                                        faucibus. Proin nec elit varius, consequat erat ut,  </p>
                                    <h2 className='pt-3 text-[#272C34] text-[12px] font-bold'> Location </h2>
                                    <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                                    <h1 className='pt-3 text-[12px] font-bold text-[#272C34]'>Timings  <strong className=' pl-3 text-lime-500'> ︳Open Now</strong> </h1>

                                    <h1 className='py-3 text-[12px] text-[#272C34] '><strong>Services </strong></h1>
                                    <div className='flex justify-between md:ml-8 md:w-[50%] mx-4  '>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>

                                            </ul>
                                        </div>
                                    </div>
                                    <h1 className='text-[#409BF5] text-[12px] py-4'><strong>View detail </strong></h1>
                                   <Link to="/BookCourt" > <button className='w-full bg-[#e8f4fe] rounded-lg py-3 text-[#409bf5] text-[14px] font-bold'>Book Now </button></Link>
                                </div>
                            </div>


                            <div className='md:md:flex my-6'>

                                <div className='card-img   md:w-[65%] w-[90%] mx-auto'>
                                    <img src={cardf} alt='card img' className='w-full md:w-[276px] h-[368px] ' />
                                </div>

                                <div className='card-text mx-4 md:mx-0'>
                                    <h1 className='text-[24px] text-[#272C34] font-bold py-1'>Padel Buddy Court name</h1>
                                    <p className='text-[#6A7D95] leading-[16px] font-normal text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                        Aliquam ullamcorper tempus sodales. Proin malesuada metus
                                        sed orci vestibulum dapibus. Morbi in mi sit amet quam feugiat
                                        faucibus. Proin nec elit varius, consequat erat ut,  </p>
                                    <h2 className='pt-3 text-[#272C34] text-[12px] font-bold'> Location </h2>
                                    <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                                    <h1 className='pt-3 text-[12px] font-bold text-[#272C34]'>Timings  <strong className=' pl-3 text-lime-500'> ︳Open Now</strong> </h1>

                                    <h1 className='py-3 text-[12px] text-[#272C34] '><strong>Services </strong></h1>
                                    <div className='flex justify-between md:ml-8 md:w-[50%] mx-4  '>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>

                                            </ul>
                                        </div>
                                    </div>
                                    <h1 className='text-[#409BF5] text-[12px] py-4'><strong>View detail </strong></h1>
                                   <Link to="/BookCourt" > <button className='w-full bg-[#e8f4fe] rounded-lg py-3 text-[#409bf5] text-[14px] font-bold'>Book Now </button></Link>
                                </div>
                            </div>


                            <div className='md:md:flex my-6'>

                                <div className='card-img   md:w-[65%] w-[90%] mx-auto'>
                                    <img src={cardfv} alt='card img' className='w-full md:w-[276px] h-[368px] ' />
                                </div>

                                <div className='card-text mx-4 md:mx-0'>
                                    <h1 className='text-[24px] text-[#272C34] font-bold py-1'>Padel Buddy Court name</h1>
                                    <p className='text-[#6A7D95] leading-[16px] font-normal text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                        Aliquam ullamcorper tempus sodales. Proin malesuada metus
                                        sed orci vestibulum dapibus. Morbi in mi sit amet quam feugiat
                                        faucibus. Proin nec elit varius, consequat erat ut,  </p>
                                    <h2 className='pt-3 text-[#272C34] text-[12px] font-bold'> Location </h2>
                                    <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                                    <h1 className='pt-3 text-[12px] font-bold text-[#272C34]'>Timings  <strong className=' pl-3 text-lime-500'> ︳Open Now</strong> </h1>

                                    <h1 className='py-3 text-[12px] text-[#272C34] '><strong>Services </strong></h1>
                                    <div className='flex justify-between md:ml-8 md:w-[50%] mx-4  '>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>

                                            </ul>
                                        </div>
                                    </div>
                                    <h1 className='text-[#409BF5] text-[12px] py-4'><strong>View detail </strong></h1>
                                   <Link to="/BookCourt" > <button className='w-full bg-[#e8f4fe] rounded-lg py-3 text-[#409bf5] text-[14px] font-bold'>Book Now </button></Link>
                                </div>
                            </div>

 
                            {/* hidden div */}


                           {show?  <div>
                                
                       
                            <div className='md:md:flex my-6'>

                                <div className='card-img   md:w-[65%] w-[90%] mx-auto'>
                                    <img src={cardt} alt='card img' className='w-full md:w-[276px] h-[368px] ' />
                                </div>

                                <div className='card-text mx-4 md:mx-0'>
                                    <h1 className='text-[24px] text-[#272C34] font-bold py-1'>Padel Buddy Court name</h1>
                                    <p className='text-[#6A7D95] leading-[16px] font-normal text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                        Aliquam ullamcorper tempus sodales. Proin malesuada metus
                                        sed orci vestibulum dapibus. Morbi in mi sit amet quam feugiat
                                        faucibus. Proin nec elit varius, consequat erat ut,  </p>
                                    <h2 className='pt-3 text-[#272C34] text-[12px] font-bold'> Location </h2>
                                    <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                                    <h1 className='pt-3 text-[12px] font-bold text-[#272C34]'>Timings  <strong className=' pl-3 text-lime-500'> ︳Open Now</strong> </h1>

                                    <h1 className='py-3 text-[12px] text-[#272C34] '><strong>Services </strong></h1>
                                    <div className='flex justify-between md:ml-8 md:w-[50%] mx-4  '>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>

                                            </ul>
                                        </div>
                                    </div>
                                    <h1 className='text-[#409BF5] text-[12px] py-4'><strong>View detail </strong></h1>
                                   <Link to="/BookCourt" > <button className='w-full bg-[#e8f4fe] rounded-lg py-3 text-[#409bf5] text-[14px] font-bold'>Book Now </button></Link>
                                </div>
                            </div>


                            <div className='md:md:flex my-6'>

                                <div className='card-img   md:w-[65%] w-[90%] mx-auto'>
                                    <img src={cardth} alt='card img' className='w-full md:w-[276px] h-[368px] ' />
                                </div>

                                <div className='card-text mx-4 md:mx-0'>
                                    <h1 className='text-[24px] text-[#272C34] font-bold py-1'>Padel Buddy Court name</h1>
                                    <p className='text-[#6A7D95] leading-[16px] font-normal text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                        Aliquam ullamcorper tempus sodales. Proin malesuada metus
                                        sed orci vestibulum dapibus. Morbi in mi sit amet quam feugiat
                                        faucibus. Proin nec elit varius, consequat erat ut,  </p>
                                    <h2 className='pt-3 text-[#272C34] text-[12px] font-bold'> Location </h2>
                                    <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                                    <h1 className='pt-3 text-[12px] font-bold text-[#272C34]'>Timings  <strong className=' pl-3 text-lime-500'> ︳Open Now</strong> </h1>

                                    <h1 className='py-3 text-[12px] text-[#272C34] '><strong>Services </strong></h1>
                                    <div className='flex justify-between md:ml-8 md:w-[50%] mx-4  '>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>

                                            </ul>
                                        </div>
                                    </div>
                                    <h1 className='text-[#409BF5] text-[12px] py-4'><strong>View detail </strong></h1>
                                   <Link to="/BookCourt" > <button className='w-full bg-[#e8f4fe] rounded-lg py-3 text-[#409bf5] text-[14px] font-bold'>Book Now </button></Link>
                                </div>
                            </div>


                            <div className='md:md:flex my-6'>

                                <div className='card-img   md:w-[65%] w-[90%] mx-auto'>
                                    <img src={cardf} alt='card img' className='w-full md:w-[276px] h-[368px] ' />
                                </div>

                                <div className='card-text mx-4 md:mx-0'>
                                    <h1 className='text-[24px] text-[#272C34] font-bold py-1'>Padel Buddy Court name</h1>
                                    <p className='text-[#6A7D95] leading-[16px] font-normal text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                        Aliquam ullamcorper tempus sodales. Proin malesuada metus
                                        sed orci vestibulum dapibus. Morbi in mi sit amet quam feugiat
                                        faucibus. Proin nec elit varius, consequat erat ut,  </p>
                                    <h2 className='pt-3 text-[#272C34] text-[12px] font-bold'> Location </h2>
                                    <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                                    <h1 className='pt-3 text-[12px] font-bold text-[#272C34]'>Timings  <strong className=' pl-3 text-lime-500'> ︳Open Now</strong> </h1>

                                    <h1 className='py-3 text-[12px] text-[#272C34] '><strong>Services </strong></h1>
                                    <div className='flex justify-between md:ml-8 md:w-[50%] mx-4  '>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>

                                            </ul>
                                        </div>
                                    </div>
                                    <h1 className='text-[#409BF5] text-[12px] py-4'><strong>View detail </strong></h1>
                                   <Link to="/BookCourt" > <button className='w-full bg-[#e8f4fe] rounded-lg py-3 text-[#409bf5] text-[14px] font-bold'>Book Now </button></Link>
                                </div>
                            </div>


                            <div className='md:md:flex my-6'>

                                <div className='card-img   md:w-[65%] w-[90%] mx-auto'>
                                    <img src={cardfv} alt='card img' className=' w-full md:w-[276px] h-[368px] ' />
                                </div>

                                <div className='card-text mx-4 md:mx-0'>
                                    <h1 className='text-[24px] text-[#272C34] font-bold py-1'>Padel Buddy Court name</h1>
                                    <p className='text-[#6A7D95] leading-[16px] font-normal text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                        Aliquam ullamcorper tempus sodales. Proin malesuada metus
                                        sed orci vestibulum dapibus. Morbi in mi sit amet quam feugiat
                                        faucibus. Proin nec elit varius, consequat erat ut,  </p>
                                    <h2 className='pt-3 text-[#272C34] text-[12px] font-bold'> Location </h2>
                                    <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                                    <h1 className='pt-3 text-[12px] font-bold text-[#272C34]'>Timings  <strong className=' pl-3 text-lime-500'> ︳Open Now</strong> </h1>

                                    <h1 className='py-3 text-[12px] text-[#272C34] '><strong>Services </strong></h1>
                                    <div className='flex justify-between md:ml-8 md:w-[50%] mx-4  '>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul className='text-[12px] font-semibold text-[ #6A7D95]'>
                                                <li>Service name</li>
                                                <li>Service name</li>
                                                <li>Service name</li>

                                            </ul>
                                        </div>
                                    </div>
                                    <h1 className='text-[#409BF5] text-[12px] py-4'><strong>View detail </strong></h1>
                                   <Link to="/BookCourt" > <button className='w-full bg-[#e8f4fe] rounded-lg py-3 text-[#409bf5] text-[14px] font-bold'>Book Now </button></Link>
                                </div>
                            </div>

 
                            </div>:null}

                 <button className='w-full bg-[#e8f4fe] rounded-lg py-3 text-[#409bf5] font-bold' onClick={()=>setShow(true)} >Load More</button>



                            {/* search result cards  end*/}

                        </div>
                    </div>
                    {/* Left side end */}

                </div>
            </div>
        </>
    )
}

export default SearchComp